import React, { useState } from 'react';

function SendTestEmail() {
  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('');
  const [html, setHtml] = useState('');
  const [message, setMessage] = useState('');

  const handleSend = async () => {
    try {
      const res = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to, subject, html })
      });

      const data = await res.json();
      if (res.ok) {
        setMessage('✅ Email sent!');
      } else {
        setMessage(`❌ Error: ${data.error}`);
      }
    } catch (err) {
      console.error(err);
      setMessage('❌ Failed to send email');
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Send Test Email</h2>
      <input
        type="email"
        placeholder="Recipient Email"
        value={to}
        onChange={e => setTo(e.target.value)}
        style={{ display: 'block', marginBottom: 10 }}
      />
      <input
        type="text"
        placeholder="Subject"
        value={subject}
        onChange={e => setSubject(e.target.value)}
        style={{ display: 'block', marginBottom: 10 }}
      />
      <textarea
        placeholder="HTML Content"
        value={html}
        onChange={e => setHtml(e.target.value)}
        style={{ display: 'block', marginBottom: 10, height: 100, width: '100%' }}
      />
      <button onClick={handleSend}>Send Email</button>
      {message && <p>{message}</p>}
    </div>
  );
}

export default SendTestEmail;
